export const ACTIVE_QUEUE_POLL_INTERVAL_MS = 10_000;
export const IDLE_QUEUE_POLL_INTERVAL_MS = 60_000;
export const ACTIVE_COVERAGE_POLL_INTERVAL_MS = 15_000;

type QueueStatusSummary = {
    readonly byStatus: readonly { readonly count: number }[];
};

export const getActiveQueueJobCount = (queueStatus: QueueStatusSummary | undefined): number =>
    queueStatus?.byStatus.reduce((sum, row) => sum + row.count, 0) ?? 0;

export const getQueuePollInterval = (queueStatus: QueueStatusSummary | undefined): number =>
    getActiveQueueJobCount(queueStatus) > 0 ? ACTIVE_QUEUE_POLL_INTERVAL_MS : IDLE_QUEUE_POLL_INTERVAL_MS;
